// import React from "react";
// import "./App.css";
// import {
//   BrowserRouter as Router,
//   Route,
//   Routes,
//   Navigate,
// } from "react-router-dom";
// import Login from "./pages/login/Login";
// import Dashboard from "./pages/Dashboard";
// import PrivateRoute from "./utils/PrivateRoute";
// import { UserProvider } from "./contexts/UserContext";
// import { ThemeProvider } from "./contexts/ThemeContext";
// import ProductsPage from "./pages/product/ProductsPage";
// import EditProductPage from "./pages/product/EditProductPage";
// import AppLayout from "./components/AppLayout";
// import NotFound from "./pages/not_fond/NotFound"; // Import the NotFound component
// import BlogIndexPage from "./pages/blog/BlogIndexPage";
// import AddBlogPage from "./pages/blog/AddBlogPage";
// import EditBlogPage from "./pages/blog/EditBlogPage";
// import Banner from "./pages/landing/banner/Banner";
// import Comment from "./pages/landing/faq/FaqIndex";
// import Content from "./pages/landing/content/Content";
// import FaqIndex from "./pages/landing/faq/FaqIndex";
// import AddFAQ from "./pages/landing/faq/FaqAdd";
// import EditFAQ from "./pages/landing/faq/FaqEdit";
// import CategoryIndex from "./pages/category/CategoryIndex";
// import AddCategoryPage from "./pages/category/AddCategoryPage";
// import EditCategoryPage from "./pages/category/EditCategoryPage";
// import BrandIndex from "./pages/brand/BrandIndex";
// import AddBrand from "./pages/brand/AddBrand";
// import EditBrand from "./pages/brand/EditBrand";
// import UserIndex from "./pages/user/UserIndex";
// import UserForm from "./pages/user/UserForm";
// import AttributesPage from "./pages/attribute/AttributesPage";
// import RoleManagement from "./pages/user/role";
// import SettingList from "./pages/setting/Setting";
// import UsersPage from "./pages/user/UserIndex";
// import { isAuthenticated } from "./services/auth";
// import OrderList from "./components/orders/OrderList";
// import OrderDetail from "./components/orders/OrderDetails";
// import SubscriptionPage from "./pages/subscription/subscription";
// import NotificationsPage from "./pages/notifications/notifications";
// import UnreadNotificationsPage from "./pages/notifications/unreadNotification";
// import MyNotificationsPage from "./pages/notifications/myNotification";
// import ProductPage from "./pages/product/productSteps";
// import CommentsPage from "./pages/comments/Comments";
// import FaqBlogList from "./pages/faq/blog faq/FaqBlogIndex";
// import AddFaqBlog from "./pages/faq/blog faq/AddFaqBlog";
// import EditFaqBlog from "./pages/faq/blog faq/EditFaqBlog";
// import FaqCreate from "./pages/faq/plan faq/AddFaqPlan";
// import FaqEdit from "./pages/faq/plan faq/EditFaqPlan";
// import MediaGallery from "./pages/gallery/Gallery";
// import ProductIndex from "./pages/product/main product/productIndex";
// import AddProduct from "./pages/product/main product/addProduct";
// import CategoryBlogIndex from "./pages/blog/blog category/blogCategoryIndex";
// import AddCategoryBlogPage from "./pages/blog/blog category/addBlogCategory";
// import EditCategoryBlogPage from "./pages/blog/blog category/editBlogCategory";
// import ProductVariationIndex from "./pages/product/ProductsPage";
// import AddVariationProduct from "./pages/product/AddProductPage";
// import EditProductVariation from "./pages/product/EditProductPage";
// import EditProduct from "./pages/product/main product/editProduct";
// import Carriers from "./pages/career/careerIndex";
// import AddEditCarrier from "./pages/career/careerCreate";
// import CommentSettings from "./pages/setting/comment_settng";
// import SEOSettings from "./pages/setting/seo_setting";
// import SiteSettings from "./pages/setting/site_setting";
// import CarListPage from "./pages/car/carIndex";
// import AddCar from "./pages/car/addCar";
// import EditCar from "./pages/car/editCar";
// import CarTypeListPage from "./pages/car_type/carTypeIndex";
// import AddCarType from "./pages/car_type/carTypeAdd";
// import EditCarType from "./pages/car_type/carTypeEdit";
// import SellerIndex from "./pages/seller/seller";
// import AddSeller from "./pages/seller/addSeller";
// import EditSeller from "./pages/seller/editSeller";
// import CountryIndex from "./pages/country/country";
// import AddCountry from "./pages/country/addCountry";
// import EditCountry from "./pages/country/editCountry";
// import GuaranteeIndex from "./pages/guarantee/guarantee";
// import AddGuarantee from "./pages/guarantee/addGuarantee";
// import EditGuarantee from "./pages/guarantee/editGuarantee";

// function App() {
//   return (
//     <ThemeProvider>
//       <UserProvider>
//         <Router>
//           <Routes>
//             <Route path="/login" element={<Login />} />
//             {/* <Route
//               path="/"
//               element={
//                 <PrivateRoute>
//                   <AppLayout />
//                 </PrivateRoute>
//               }
//             > */}
//             <Route
//               path="/"
//               element={
//                 isAuthenticated() ? (
//                   <AppLayout />
//                 ) : (
//                   <Navigate to="/login" replace />
//                 )
//               }
//             >
//               <Route index element={<Navigate to="/dashboard" replace />} />
//               <Route path="/dashboard" element={<Dashboard />} />

//               <Route path="products" element={<ProductIndex />} />
//               <Route path="products/add" element={<AddProduct />} />
//               <Route path="products/edit/:id" element={<EditProduct />} />
//               <Route
//                 path="productsVariation"
//                 element={<ProductVariationIndex />}
//               />
//               <Route
//                 path="productsVariation/add/:productId"
//                 element={<AddVariationProduct />}
//               />
//               <Route
//                 path="productsVariation/edit/:id"
//                 element={<EditProductVariation />}
//               />

//               <Route path="/categories" element={<CategoryIndex />} />
//               <Route path="/categories/add" element={<AddCategoryPage />} />
//               <Route
//                 path="/categories/edit/:id"
//                 element={<EditCategoryPage />}
//               />

//               <Route path="/users" element={<UsersPage />} />
//               {/* <Route path="/users/add" element={<UserForm />} />
//               <Route path="/users/edit/:id" element={<UserForm />} /> */}

//               <Route path="/roles" element={<RoleManagement />} />

//               <Route path="/setting" element={<SettingList />} />
//               <Route path="/site_setting" element={<SiteSettings />} />
//               <Route path="/comment_setting" element={<CommentSettings />} />
//               <Route path="/seo_setting" element={<SEOSettings />} />
//               <Route path="/category_setting" element={<SettingList />} />
//               <Route path="/setting_pay" element={<SettingList />} />

//               <Route path="/attributes" element={<AttributesPage />} />

//               <Route path="/brands" element={<BrandIndex />} />
//               <Route path="/brands/add" element={<AddBrand />} />
//               <Route path="/brands/edit/:id" element={<EditBrand />} />

//               <Route path="/blogs" element={<BlogIndexPage />} />
//               <Route path="/blogs/add" element={<AddBlogPage />} />
//               <Route path="/blogs/edit/:id" element={<EditBlogPage />} />

//               <Route path="/blog-categories" element={<CategoryBlogIndex />} />
//               <Route
//                 path="/blog-categories/add"
//                 element={<AddCategoryBlogPage />}
//               />
//               <Route
//                 path="/blog-categories/edit/:id"
//                 element={<EditCategoryBlogPage />}
//               />

//               <Route path="/orders" element={<OrderList />} />
//               <Route path="/orders/:id" element={<OrderDetail />} />

//               <Route path="/subscription" element={<SubscriptionPage />} />

//               <Route path="/career" element={<Carriers />} />
//               <Route path="/carriers/add" element={<AddEditCarrier />} />
//               <Route path="/carriers/edit/:id" element={<AddEditCarrier />} />

//               <Route path="/car" element={<CarListPage />} />
//               <Route path="/car/add" element={<AddCar />} />
//               <Route path="/car/edit/:id" element={<EditCar />} />

//               <Route path="/car_type" element={<CarTypeListPage />} />
//               <Route path="/car_type/add" element={<AddCarType />} />
//               <Route path="/car_type/edit/:id" element={<EditCarType />} />

//               <Route path="/tax_seller" element={<SellerIndex />} />
//               <Route path="/tax_seller/add" element={<AddSeller />} />
//               <Route path="/tax_seller/edit/:id" element={<EditSeller />} />

//               <Route path="/country" element={<CountryIndex />} />
//               <Route path="/country/add" element={<AddCountry />} />
//               <Route path="/country/edit/:id" element={<EditCountry />} />

//               <Route path="/guarantee" element={<GuaranteeIndex />} />
//               <Route path="/guarantee/add" element={<AddGuarantee />} />
//               <Route path="/guarantee/edit/:id" element={<EditGuarantee />} />

//               <Route path="/comments" element={<CommentsPage />} />

//               <Route path="/faq/plan" element={<FaqIndex />} />
//               <Route path="/faq/plan/add" element={<FaqCreate />} />
//               <Route path="/faq/plan/edit/:id" element={<FaqEdit />} />

//               <Route path="/faq/blog" element={<FaqBlogList />} />
//               <Route path="/faq/blog/add" element={<AddFaqBlog />} />
//               <Route path="/faq/blog/edit/:id" element={<EditFaqBlog />} />

//               <Route path="/notifications" element={<NotificationsPage />} />
//               <Route
//                 path="/my_notifications"
//                 element={<MyNotificationsPage />}
//               />
//               <Route
//                 path="/unread_notifications"
//                 element={<UnreadNotificationsPage />}
//               />

//               <Route path="/gallery" element={<MediaGallery />} />

//               <Route path="/landing/banner" element={<Banner />} />
//               <Route path="/landing/faq_list" element={<FaqIndex />} />
//               <Route path="/add-faq" element={<AddFAQ />} />
//               <Route path="/edit-faq/:id" element={<EditFAQ />} />
//               <Route path="/landing/content" element={<Content />} />
//             </Route>
//             <Route path="/404" element={<NotFound />} />
//             <Route path="*" element={<Navigate to="/404" replace />} />
//           </Routes>
//         </Router>
//       </UserProvider>
//     </ThemeProvider>
//   );
// }

import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { UserProvider } from "./contexts/UserContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { isAuthenticated } from "./services/auth";
import AppLayout from "./components/AppLayout";
import Login from "./pages/login/Login";
import NotFound from "./pages/not_fond/NotFound";
import Dashboard from "./pages/Dashboard";

import productRoutes from "./routes/productRoutes";
import blogRoutes from "./routes/blogRoutes";
import categoryRoutes from "./routes/categoryRoutes";
import brandRoutes from "./routes/brandRoutes";
import userRoutes from "./routes/userRoutes";
import carRoutes from "./routes/carRoutes";
import carTypeRoutes from "./routes/carTypeRoutes";
import faqRoutes from "./routes/faqRoutes";
import notificationRoutes from "./routes/notificationRoutes";
import settingRoutes from "./routes/settingRoutes";
import GalleryPage from "./pages/gallery/Gallery";
import carrierRoutes from "./routes/carrierRoutes";
import countryRoutes from "./routes/countryRoutes";
import guaranteeRoutes from "./routes/guaranteeRoutes";
import sellerRoutes from "./routes/sellerRoutes";
import EventsPage from "./pages/event/event";
import ExcelExportPage from "./pages/excel/excel";
import CommentIndex from "./pages/comments/Comments";
import discountRoutes from "./routes/discountRoutes";
import InternationalRequestsIndex from "./pages/ticket/international_request";
import EmailSubscriptionIndex from "./pages/ticket/email_subscription";
import pageRoutes from "./routes/pagesRoutes";
import orderRoutes from "./routes/orderRoutes";
import redirectRoutes from "./routes/redirectRoutes";
import PriceChangeLog from "./pages/reports/priceReport";
import ProductChangeLog from "./pages/reports/productReport";
import Ticket from "./pages/ticket/ticket";
import PartRequest from "./pages/ticket/part_request";
import BranchObtain from "./pages/ticket/branch_obtain ";

function App() {
  return (
    <ThemeProvider>
      <UserProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                isAuthenticated() ? (
                  <AppLayout />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              {/* Use modular routes */}
              {productRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              {/* {blogRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))} */}
              {categoryRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              {sellerRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              {countryRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              {guaranteeRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              {orderRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              {carrierRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              {brandRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              {discountRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              {pageRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              {redirectRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              <Route
                path="/ticket/email_subscription"
                element={<EmailSubscriptionIndex />}
              />
              <Route
                path="/ticket"
                element={<Ticket />}
              />
              <Route
                path="/ticket/part_request"
                element={<PartRequest />}
              />
               <Route
                path="/ticket/branch_obtain"
                element={<BranchObtain />}
              />
               
              <Route
                path="/ticket/international_request"
                element={<InternationalRequestsIndex />}
              />
              <Route path="/price-report" element={<PriceChangeLog />} />
              <Route path="/product-report" element={<ProductChangeLog />} />

              
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/event" element={<EventsPage />} />
              <Route path="/excel" element={<ExcelExportPage />} />
              <Route path="/comments" element={<CommentIndex />} />
              {userRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              {carRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              {carTypeRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              {faqRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              {/* {notificationRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))} */}
              {settingRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
            </Route>
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </Router>
      </UserProvider>
    </ThemeProvider>
  );
}

export default App;
